/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RecipientProviderType = {
    SkilledNursing: 'SKILLED_NURSING',
    HomeHealth: 'HOME_HEALTH',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospice: 'HOSPICE',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospital: 'HOSPITAL',
} as const;
export type RecipientProviderType = typeof RecipientProviderType[keyof typeof RecipientProviderType];


export function instanceOfRecipientProviderType(value: any): boolean {
    for (const key in RecipientProviderType) {
        if (Object.prototype.hasOwnProperty.call(RecipientProviderType, key)) {
            if (RecipientProviderType[key as keyof typeof RecipientProviderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RecipientProviderTypeFromJSON(json: any): RecipientProviderType {
    return RecipientProviderTypeFromJSONTyped(json, false);
}

export function RecipientProviderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientProviderType {
    return json as RecipientProviderType;
}

export function RecipientProviderTypeToJSON(value?: RecipientProviderType | null): any {
    return value as any;
}

export function RecipientProviderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RecipientProviderType {
    return value as RecipientProviderType;
}

